import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { FRAUD_MODE, FRAUD_MODE_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetParam,
    asyncGetFraudModeHistorical,
    asyncPatchFraudModeParam,
    asyncPostFraudModeParam,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const useFraudModeForm = () => {
    const navigate = useNavigate();
    const { idFraudMode } = useParams();
    const [fraudMode, setFraudMode] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikFraudModeData, setFormikFraudModeData] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [fraudModeHistorical, setFraudModeHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikFraudModeData?.isValid;

    const handleCleanAndBack = () => {
        formikFraudModeData?.resetForm();
        navigate(FRAUD_MODE);
    };

    const handleSubmit = async () => {
        await formikFraudModeData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikFraudModeData?.values;

        let res: any | undefined = undefined;

        try {
            if (fraudMode && fraudMode.id)
                res = await asyncPatchFraudModeParam(fraudMode.id, data);
            else res = await asyncPostFraudModeParam(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! la modalidad de fraude se ${
                    fraudMode && fraudMode.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${FRAUD_MODE_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    fraudMode && fraudMode.id ? 'actualizar' : 'crear'
                } la modalidad de fraude. Por favor, asegúrate de ${
                    fraudMode && fraudMode.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idFraudMode)) {
            setLoading(true);
            asyncGetParam(idFraudMode)
                .then((fraudMode: any) => {
                    if (!fraudMode || !fraudMode.items) navigate(FRAUD_MODE);
                    setFraudMode(fraudMode?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idFraudMode]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetFraudModeHistorical(idFraudMode)
                .then((resp) => {
                    if (resp) setFraudModeHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        fraudMode,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikFraudModeData,
        fraudModeHistorical,
        showHistorical,
        setShowHistorical,
    };
};
